import React from 'react';
import ReactDOM from 'react-dom';
import 'styles/global-styles.scss';
import App from 'components/App';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('web-developer-root')
);

serviceWorker.unregister();
